<!-- eslint-disable max-len vue/no-v-html -->
<template>
  <div>
    <LoadingSpinner v-if="loading"/>
    <div v-if="!loading" class="userprofil_block block relative w-full">
      <div class="block relative px-4 pb-8">
        <div class="info-block block relative">
          <div class="top-block block relative">
            <h4
                class="
                page-title
                block
                relative
                text-lgg
                font-bold
                mb-4
                text-center
              "
            >
              {{ $t("pages.user_profile.title") }}
            </h4>
            <div class="flex items-center justify-center w-full mb-4">
              <div>
                <img
                    class="block rounded-full ring-2 ring-white w-full h-full"
                    style="height: 64px; width: 64px; left: 16px; top: 64px"
                    v-if="user.pic_url_thumb"
                    :src="user.pic_url_thumb"
                    alt=""
                />
                <img
                    class="block rounded-full ring-2 ring-white w-full h-full"
                    style="height: 64px; width: 64px; left: 16px; top: 64px"
                    v-if="!user.pic_url_thumb"
                    src="./../../assets/images/portrait_placeholder.png"
                    alt=""
                />
                <!-- <img
                  :src="`${
                    pic ||
                    user.pic_url_thumb ||
                    './../../assets/images/profile-img1.png'
                  }`"
                  class="w-full h-full"
                /> -->
              </div>
            </div>
            <input
                ref="profilePic"
                type="file"
                style="display: none"
                accept="image/png,image/jpeg"
                @change="handleFileUpload('profile-pic', $event)"
            />
            <p
                class="
                flex
                items-center
                justify-center
                text-center
                px-1
                mb-4
                font-medium
                px-8
                text-darkgreen
              "
                @click="$refs.profilePic.click()"
            >
              <span class="icon-block block mr-2">
                <svg
                    width="22"
                    height="23"
                    class="w-3.5 h-3.5"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M20.94 11.0499L11.75 20.2399C10.6242 21.3658 9.09723 21.9983 7.50505 21.9983C5.91286 21.9983 4.38589 21.3658 3.26005 20.2399C2.1342 19.1141 1.50171 17.5871 1.50171 15.9949C1.50171 14.4027 2.1342 12.8758 3.26005 11.7499L12.45 2.55992C13.2006 1.80936 14.2186 1.3877 15.28 1.3877C16.3415 1.3877 17.3595 1.80936 18.11 2.55992C18.8606 3.31048 19.2823 4.32846 19.2823 5.38992C19.2823 6.45138 18.8606 7.46936 18.11 8.21992L8.91005 17.4099C8.53476 17.7852 8.02577 17.996 7.49505 17.996C6.96432 17.996 6.45533 17.7852 6.08005 17.4099C5.70476 17.0346 5.49393 16.5256 5.49393 15.9949C5.49393 15.4642 5.70476 14.9552 6.08005 14.5799L14.57 6.09992"
                      stroke="#63B15B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                  />
                </svg>
              </span>
              {{ $t("pages.user_profile.image_upload_title") }}
            </p>

            <p
                class="
                page-subtitle
                block
                relative
                text-sm
                font-medium
                mb-4
                text-center
                px-8
                text-darkgray1
              "
                v-html="$t('pages.user_profile.subtitle')"
            ></p>
          </div>

          <div class="12">
            <!-- start -->
            <div class="form-group block relative mb-4">
              <label
                  class="
                  label_text
                  block
                  relative
                  text-xs text-left text-black
                  mb-1
                  font-bold
                  text-darkblack
                "
              >
                {{ $t("pages.user_profile.first_name") }}
              </label>
              <input
                  v-model.trim="firstName"
                  type="text"
                  name=""
                  class="w-full h-12 text-sm placeholder-current form_control"
                  placeholder="Albert"
                  pattern="^[a-zA-Z]+$"
                  @keypress="isLetter"
                  @input="$event.target.composing = false"
              />
            </div>
            <!-- end -->
            <!-- start -->
            <div class="form-group block relative mb-4">
              <label
                  class="
                  label_text
                  block
                  relative
                  text-xs text-left text-black
                  mb-1
                  font-bold
                  text-darkblack
                "
              >
                {{ $t("pages.user_profile.surname") }}
              </label>
              <input
                  v-model.trim="lastName"
                  type="text"
                  name=""
                  class="w-full h-12 text-sm placeholder-current form_control"
                  placeholder="Alexander"
                  pattern="^[a-zA-Z]+$"
                  @keypress="isLetter"
                  @input="$event.target.composing = false"
              />
            </div>
            <!-- end -->
            <!-- start -->
            <div class="form-group block relative mb-4">
              <div
                  class="
                  input-group
                  flex
                  items-start
                  justify-start
                  p-0
                  border
                  solid
                  border-color
                  rounded
                  h-12
                "
              >
                <span
                    class="
                    h-full
                    flex
                    items-center
                    w-1/6
                    justify-center
                    input-group-adddon
                    text-darkgray1
                    font-medium
                    text-sm
                    border-r
                    solid
                    border-color
                  "
                >
                  +49
                </span>
                <input
                    v-model="cell"
                    type="tel"
                    name=""
                    class="
                    placeholder-current
                    h-full
                    w-5/6
                    form-control
                    outline-none
                    icon-2
                    text-darkgray1
                    font-medium
                    text-sm
                    pl-2
                    pr-2
                    bg-transparent
                    rounded
                  "
                    placeholder="233 123 233"
                    @keypress="onlyNumber"
                />
              </div>
            </div>
            <!-- end -->

            <!-- start -->
            <SearchCard
                :label="$t('pages.common.buttons.dis78')"
                custom-class="label_text block relative text-xs text-left text-black mb-1 font-bold text-darkblack"
                v-model="availabilityDate"
                @date="
                (val) => {
                  availabilityDate = val;
                }
              "
            />
            <p
                class="
                flex
                items-center
                justify-start
                text-left
                mb-4
                font-medium
                text-darkgreen text-sm
                mt-4
              "
                @click="openDocPopup = !openDocPopup"
            >
              <span class="icon-block block mr-2">
                <svg
                    width="22"
                    height="23"
                    class="w-3.5 h-3.5"
                    viewBox="0 0 22 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M20.94 11.0499L11.75 20.2399C10.6242 21.3658 9.09723 21.9983 7.50505 21.9983C5.91286 21.9983 4.38589 21.3658 3.26005 20.2399C2.1342 19.1141 1.50171 17.5871 1.50171 15.9949C1.50171 14.4027 2.1342 12.8758 3.26005 11.7499L12.45 2.55992C13.2006 1.80936 14.2186 1.3877 15.28 1.3877C16.3415 1.3877 17.3595 1.80936 18.11 2.55992C18.8606 3.31048 19.2823 4.32846 19.2823 5.38992C19.2823 6.45138 18.8606 7.46936 18.11 8.21992L8.91005 17.4099C8.53476 17.7852 8.02577 17.996 7.49505 17.996C6.96432 17.996 6.45533 17.7852 6.08005 17.4099C5.70476 17.0346 5.49393 16.5256 5.49393 15.9949C5.49393 15.4642 5.70476 14.9552 6.08005 14.5799L14.57 6.09992"
                      stroke="#63B15B"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                  />
                </svg>
              </span>

              {{ $t("pages.user_profile.upload_document") }}
            </p>
            <!-- end -->
          </div>
        </div>

        <ul
            style="list-style-type: none"
            v-for="docs in documentsList"
            :key="docs.id"
        >


          <li>
            <svg
                width="16"
                height="17"
                class="w-4 h-4"

                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M2.16675 0.833984C1.33975 0.833984 0.666748 1.50698 0.666748 2.33398V12.6673C0.666748 13.4943 1.33975 14.1673 2.16675 14.1673H9.83341C10.6604 14.1673 11.3334 13.4943 11.3334 12.6673V6.16732H7.50008C6.67308 6.16732 6.00008 5.49432 6.00008 4.66732V0.833984H2.16675ZM7.00008 1.12695V4.66732C7.00008 4.94299 7.22441 5.16732 7.50008 5.16732H11.0404L7.00008 1.12695ZM3.83341 7.83399H8.16675C8.44275 7.83399 8.66675 8.05799 8.66675 8.33399C8.66675 8.60999 8.44275 8.83399 8.16675 8.83399H3.83341C3.55741 8.83399 3.33341 8.60999 3.33341 8.33399C3.33341 8.05799 3.55741 7.83399 3.83341 7.83399ZM3.83016 10.1673H6.82886C7.10486 10.1673 7.32886 10.391 7.32886 10.6673C7.32919 10.9203 7.14122 11.1298 6.89722 11.1628L6.82951 11.1673H3.83081C3.55481 11.1673 3.33081 10.9433 3.33081 10.6673C3.33081 10.4143 3.51845 10.2049 3.76245 10.1719L3.83016 10.1673Z"
                  fill="#63B15B"
              />
            </svg>


            <span class="documentfilecolor">{{ docs.description }}</span>
          </li>

          <label
              class="actions flex items-center justify-end"
              style="margin-top: -18px"
          >
            <button style="    position: relative;
    top: -21px;">
              <svg
                  width="16"
                  height="17"
                  class="w-4 h-4"
                  viewBox="0 0 16 17"
                  fill="none"
                  @click="deleteicons(docs.id, docs)"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M8.00012 1.83301C6.83069 1.83301 5.85692 2.70682 5.69348 3.83301H3.41288C3.3845 3.82815 3.35574 3.82575 3.32695 3.82585C3.30206 3.82638 3.27725 3.82878 3.25273 3.83301H2.16679C2.10053 3.83207 2.03475 3.84431 1.97327 3.86902C1.91178 3.89373 1.85582 3.93041 1.80864 3.97693C1.76145 4.02345 1.72399 4.07889 1.69841 4.14002C1.67284 4.20114 1.65967 4.26675 1.65967 4.33301C1.65967 4.39927 1.67284 4.46487 1.69841 4.526C1.72399 4.58713 1.76145 4.64257 1.80864 4.68909C1.85582 4.73561 1.91178 4.77229 1.97327 4.797C2.03475 4.8217 2.10053 4.83395 2.16679 4.83301H2.87968L3.71887 13.5094C3.80923 14.445 4.60405 15.1663 5.54374 15.1663H10.4559C11.3956 15.1663 12.1904 14.4451 12.2807 13.5094L13.1206 4.83301H13.8335C13.8997 4.83395 13.9655 4.8217 14.027 4.797C14.0885 4.77229 14.1444 4.73561 14.1916 4.68909C14.2388 4.64257 14.2763 4.58713 14.3018 4.526C14.3274 4.46487 14.3406 4.39927 14.3406 4.33301C14.3406 4.26675 14.3274 4.20114 14.3018 4.14002C14.2763 4.07889 14.2388 4.02345 14.1916 3.97693C14.1444 3.93041 14.0885 3.89373 14.027 3.86902C13.9655 3.84431 13.8997 3.83207 13.8335 3.83301H12.7482C12.6951 3.8244 12.6411 3.8244 12.588 3.83301H10.3068C10.1433 2.70682 9.16956 1.83301 8.00012 1.83301ZM8.00012 2.83301C8.62651 2.83301 9.14038 3.25573 9.28723 3.83301H6.71301C6.85987 3.25573 7.37374 2.83301 8.00012 2.83301ZM3.88359 4.83301H12.116L11.2853 13.4131C11.2436 13.8448 10.8894 14.1663 10.4559 14.1663H5.54374C5.11077 14.1663 4.75596 13.8442 4.71432 13.4131L3.88359 4.83301ZM6.82564 6.49251C6.69315 6.49458 6.56689 6.54916 6.47461 6.64425C6.38232 6.73934 6.33156 6.86718 6.33346 6.99967V11.9997C6.33252 12.0659 6.34476 12.1317 6.36947 12.1932C6.39417 12.2547 6.43085 12.3106 6.47738 12.3578C6.5239 12.405 6.57933 12.4425 6.64046 12.4681C6.70159 12.4936 6.76719 12.5068 6.83346 12.5068C6.89972 12.5068 6.96532 12.4936 7.02645 12.4681C7.08758 12.4425 7.14301 12.405 7.18954 12.3578C7.23606 12.3106 7.27274 12.2547 7.29745 12.1932C7.32215 12.1317 7.33439 12.0659 7.33346 11.9997V6.99967C7.33442 6.93275 7.32193 6.86632 7.29674 6.80431C7.27156 6.7423 7.23418 6.68598 7.18682 6.63869C7.13946 6.59139 7.0831 6.55408 7.02105 6.52897C6.95901 6.50387 6.89256 6.49147 6.82564 6.49251ZM9.15898 6.49251C9.02648 6.49458 8.90023 6.54916 8.80794 6.64425C8.71566 6.73934 8.66489 6.86718 8.66679 6.99967V11.9997C8.66585 12.0659 8.67809 12.1317 8.7028 12.1932C8.72751 12.2547 8.76419 12.3106 8.81071 12.3578C8.85723 12.405 8.91267 12.4425 8.9738 12.4681C9.03493 12.4936 9.10053 12.5068 9.16679 12.5068C9.23305 12.5068 9.29866 12.4936 9.35978 12.4681C9.42091 12.4425 9.47635 12.405 9.52287 12.3578C9.56939 12.3106 9.60607 12.2547 9.63078 12.1932C9.65549 12.1317 9.66773 12.0659 9.66679 11.9997V6.99967C9.66775 6.93275 9.65527 6.86632 9.63008 6.80431C9.60489 6.7423 9.56751 6.68598 9.52015 6.63869C9.4728 6.59139 9.41643 6.55408 9.35439 6.52897C9.29235 6.50387 9.2259 6.49147 9.15898 6.49251Z"
                    fill="#333333"
                />
              </svg>
            </button>
          </label>
        </ul>

        <!-- Button -->
        <div
            class="
            button-block
            block
            mb-0
            current_action
            fixed
            left-0
            bottom-0
            w-full
            px-4
            bg-white
          "
        >
          <div class="form-group block relative mb-0  pb-4">
            <button
                class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-lg
                text-white
                btn_action
              "
                :class="{ 'disabled:opacity-50': disableSaveBtn }"
                :disabled="disableSaveBtn"
                @click="save"
            >
              {{ $t("pages.common.buttons.dis80") }}
            </button>
          </div>
        </div>
        <!-- end -->
      </div>
    </div>

    <div
        v-if="openDocPopup"
        class="modal-block block fixed left-0 top-0 w-full h-full overflow-hidden"
    >
      <div
          class="
          modal-contant
          m-overlay
          w-full
          h-full
          flex
          items-end
          justify-start
        "
      >
        <div
            class="
            modal-box
            block
            relative
            h-3/4
            w-full
            bg-white
            p-4
            rounded-t-lg
            overflow-auto
          "
        >
          <div class="modal-title flex items-center justify-start mb17-17">
            <div class="w-1/4 block relative">
              <span class="icon-block" @click="openDocPopup = !openDocPopup">
                <svg
                    width="24"
                    height="24"
                    class="w-6 h-6"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M19.7433 3.48947C19.5452 3.49414 19.357 3.577 19.2198 3.71994L12.0001 10.9397L4.78039 3.71994C4.71048 3.64794 4.62684 3.59071 4.53441 3.55163C4.44198 3.51254 4.34265 3.4924 4.2423 3.4924C4.09304 3.49243 3.94719 3.537 3.8234 3.6204C3.69961 3.70379 3.60352 3.82223 3.54741 3.96054C3.49131 4.09886 3.47775 4.25077 3.50847 4.39683C3.53918 4.5429 3.61278 4.67648 3.71984 4.78048L10.9396 12.0002L3.71984 19.2199C3.64786 19.289 3.5904 19.3718 3.55081 19.4634C3.51122 19.555 3.49031 19.6536 3.4893 19.7534C3.48828 19.8531 3.50719 19.9521 3.5449 20.0445C3.58262 20.1369 3.63839 20.2208 3.70895 20.2914C3.77951 20.3619 3.86344 20.4177 3.95582 20.4554C4.0482 20.4931 4.14718 20.512 4.24696 20.511C4.34674 20.51 4.44531 20.4891 4.53691 20.4495C4.6285 20.4099 4.71128 20.3525 4.78039 20.2805L12.0001 13.0608L19.2198 20.2805C19.2889 20.3525 19.3717 20.4099 19.4633 20.4495C19.5549 20.4891 19.6535 20.51 19.7533 20.511C19.8531 20.512 19.952 20.4931 20.0444 20.4554C20.1368 20.4177 20.2207 20.3619 20.2913 20.2914C20.3618 20.2208 20.4176 20.1369 20.4553 20.0445C20.493 19.9521 20.5119 19.8531 20.5109 19.7534C20.5099 19.6536 20.489 19.555 20.4494 19.4634C20.4098 19.3718 20.3524 19.289 20.2804 19.2199L13.0607 12.0002L20.2804 4.78048C20.3895 4.6758 20.4643 4.54061 20.4952 4.39263C20.5261 4.24465 20.5116 4.09079 20.4535 3.95121C20.3955 3.81164 20.2966 3.69287 20.1698 3.61047C20.0431 3.52807 19.8944 3.4859 19.7433 3.48947Z"
                      fill="#676666"
                  />
                </svg>
              </span>
            </div>
            <div class="w-2/4 block relative">
              <label
                  class="block text text-sm font-bold text-center"
              >
                {{ $t("pages.user_profile.document_upload.heading") }}
              </label>
            </div>
            <div class="w-1/4 block relative"></div>
          </div>

          <div class="modal-body mb-4">
            <label class="block text-darkblack text-xs font-bold mb-2">
              {{ $t("pages.user_profile.document_upload.sub_heading") }}
            </label>
            <p class="list-items block text-darkgray1 text-xs font-medium mb-2">
              1. {{ $t("pages.common.buttons.dis59") }}
            </p>
            <p class="list-items block text-darkgray1 text-xs font-medium mb-2">
              2. {{ $t("pages.common.buttons.dis60") }}
            </p>
            <p class="list-items block text-darkgray1 text-xs font-medium mb-2">
              {{ $t("pages.common.buttons.dis151") }}
            </p>
          </div>


          <div class="form-group mb-4">
            <label class="block text-darkblack text-xs font-bold mb-1-3">
              {{ $t("pages.user_profile.document_upload.Details") }}
              <p class="text-right">{{ RemainCountTotal }}/255</p>
            </label>


            <textarea
                v-model="popup.details"
                class="
                block
                relative
                h-12
                w-full
                border
                solid
                border-color
                text-black
                placeholder-darkgray
                rounded
                h-37
                pl-4
                pr-4
                pt-3
                pb-3.5
                resize-none
                font-medium
              "
                maxlength="255"
                v-on:keyup="displayLiveCDown"
            ></textarea>
            <span v-if="displayError" class="items-end error-msg">
              {{ $t("pages.common.buttons.dis102") }}
            </span>
          </div>

          <div v-if="popup.document.original === null" class="form-group mb-57">
            <input
                ref="document"
                type="file"
                multiple
                style="display: none"
                accept="application/pdf,application/rtf,text/rtf,.doc,.docx"
                @change="handleFileUpload('document', $event)"
            />

            <label
                class="
                block
                text-darkgreen text-sm
                font-medium
                flex
                items-center
                justify-start
              "

                @click="$refs.document.click()"
            >
              <span class="icon mr-2">
                <svg
                    width="16"
                    height="16"
                    class="w-4 h-4"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.5202 1.59212C9.98937 1.59212 9.48028 1.80299 9.10493 2.17834L2.97826 8.30501C2.35273 8.93055 2.0013 9.77896 2.0013 10.6636C2.0013 11.5483 2.35273 12.3967 2.97826 13.0222C3.6038 13.6477 4.45221 13.9992 5.33686 13.9992C6.2215 13.9992 7.06992 13.6477 7.69546 13.0222L13.8221 6.89553C14.0825 6.63518 14.5046 6.63518 14.7649 6.89553C15.0253 7.15588 15.0253 7.57799 14.7649 7.83834L8.63826 13.965C7.76268 14.8406 6.57513 15.3325 5.33686 15.3325C4.09859 15.3325 2.91104 14.8406 2.03546 13.965C1.15987 13.0894 0.667969 11.9019 0.667969 10.6636C0.667969 9.42534 1.15987 8.23779 2.03546 7.3622L8.16212 1.23553C8.78752 0.610135 9.63574 0.258789 10.5202 0.258789C11.4046 0.258789 12.2529 0.610135 12.8783 1.23553C13.5037 1.86093 13.855 2.70916 13.855 3.59361C13.855 4.47805 13.5037 5.32628 12.8783 5.95168L6.74493 12.0783C6.36972 12.4536 5.86082 12.6643 5.33019 12.6643C4.79956 12.6643 4.29067 12.4536 3.91546 12.0783C3.54024 11.7031 3.32945 11.1942 3.32945 10.6636C3.32945 10.133 3.54024 9.62408 3.91546 9.24887L9.57573 3.59526C9.83624 3.33506 10.2583 3.33531 10.5185 3.59581C10.7787 3.85631 10.7785 4.27842 10.518 4.53862L4.85826 10.1917C4.73327 10.3168 4.66279 10.4867 4.66279 10.6636C4.66279 10.8406 4.7331 11.0104 4.85826 11.1355C4.98343 11.2607 5.15319 11.331 5.33019 11.331C5.5072 11.331 5.67696 11.2607 5.80212 11.1355L11.9355 5.00887C12.3106 4.63354 12.5217 4.12431 12.5217 3.59361C12.5217 3.06278 12.3108 2.55369 11.9355 2.17834C11.5601 1.80299 11.051 1.59212 10.5202 1.59212Z"
                      fill="#63B15B"
                  />
                </svg>
              </span>
              {{ $t("pages.user_profile.document_upload.upload_title_detail") }}
            </label>
          </div>

          <div
              v-if="popup.document.original !== null"
              class="form-group flex items-center justify-start mb-14"
          >
            <div class="w-3/4">
              <label
                  class="
                  flex
                  align-center
                  justify-start
                  text-xs
                  font-medium
                 
                  pl-5
                "
                  style="color: #63B15B"
              >
                <span class="icon mr-2">
                  <svg
                      width="16"
                      height="16"
                      class="w-4 h-4"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.5202 1.59212C9.98937 1.59212 9.48028 1.80299 9.10493 2.17834L2.97826 8.30501C2.35273 8.93055 2.0013 9.77896 2.0013 10.6636C2.0013 11.5483 2.35273 12.3967 2.97826 13.0222C3.6038 13.6477 4.45221 13.9992 5.33686 13.9992C6.2215 13.9992 7.06992 13.6477 7.69546 13.0222L13.8221 6.89553C14.0825 6.63518 14.5046 6.63518 14.7649 6.89553C15.0253 7.15588 15.0253 7.57799 14.7649 7.83834L8.63826 13.965C7.76268 14.8406 6.57513 15.3325 5.33686 15.3325C4.09859 15.3325 2.91104 14.8406 2.03546 13.965C1.15987 13.0894 0.667969 11.9019 0.667969 10.6636C0.667969 9.42534 1.15987 8.23779 2.03546 7.3622L8.16212 1.23553C8.78752 0.610135 9.63574 0.258789 10.5202 0.258789C11.4046 0.258789 12.2529 0.610135 12.8783 1.23553C13.5037 1.86093 13.855 2.70916 13.855 3.59361C13.855 4.47805 13.5037 5.32628 12.8783 5.95168L6.74493 12.0783C6.36972 12.4536 5.86082 12.6643 5.33019 12.6643C4.79956 12.6643 4.29067 12.4536 3.91546 12.0783C3.54024 11.7031 3.32945 11.1942 3.32945 10.6636C3.32945 10.133 3.54024 9.62408 3.91546 9.24887L9.57573 3.59526C9.83624 3.33506 10.2583 3.33531 10.5185 3.59581C10.7787 3.85631 10.7785 4.27842 10.518 4.53862L4.85826 10.1917C4.73327 10.3168 4.66279 10.4867 4.66279 10.6636C4.66279 10.8406 4.7331 11.0104 4.85826 11.1355C4.98343 11.2607 5.15319 11.331 5.33019 11.331C5.5072 11.331 5.67696 11.2607 5.80212 11.1355L11.9355 5.00887C12.3106 4.63354 12.5217 4.12431 12.5217 3.59361C12.5217 3.06278 12.3108 2.55369 11.9355 2.17834C11.5601 1.80299 11.051 1.59212 10.5202 1.59212Z"
                        fill="#63B15B"
                    />
                  </svg>
                </span>
                {{ popup.document.original.name }}
              </label>
            </div>
            <div class="w-1/4">
              <label
                  class="actions flex items-center justify-end"
                  @click="
                  popup.document.original = null;
                  popup.document.thumb = null;
                "
              >
                <svg
                    width="16"
                    height="17"
                    class="w-4 h-4"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M8.00012 1.83301C6.83069 1.83301 5.85692 2.70682 5.69348 3.83301H3.41288C3.3845 3.82815 3.35574 3.82575 3.32695 3.82585C3.30206 3.82638 3.27725 3.82878 3.25273 3.83301H2.16679C2.10053 3.83207 2.03475 3.84431 1.97327 3.86902C1.91178 3.89373 1.85582 3.93041 1.80864 3.97693C1.76145 4.02345 1.72399 4.07889 1.69841 4.14002C1.67284 4.20114 1.65967 4.26675 1.65967 4.33301C1.65967 4.39927 1.67284 4.46487 1.69841 4.526C1.72399 4.58713 1.76145 4.64257 1.80864 4.68909C1.85582 4.73561 1.91178 4.77229 1.97327 4.797C2.03475 4.8217 2.10053 4.83395 2.16679 4.83301H2.87968L3.71887 13.5094C3.80923 14.445 4.60405 15.1663 5.54374 15.1663H10.4559C11.3956 15.1663 12.1904 14.4451 12.2807 13.5094L13.1206 4.83301H13.8335C13.8997 4.83395 13.9655 4.8217 14.027 4.797C14.0885 4.77229 14.1444 4.73561 14.1916 4.68909C14.2388 4.64257 14.2763 4.58713 14.3018 4.526C14.3274 4.46487 14.3406 4.39927 14.3406 4.33301C14.3406 4.26675 14.3274 4.20114 14.3018 4.14002C14.2763 4.07889 14.2388 4.02345 14.1916 3.97693C14.1444 3.93041 14.0885 3.89373 14.027 3.86902C13.9655 3.84431 13.8997 3.83207 13.8335 3.83301H12.7482C12.6951 3.8244 12.6411 3.8244 12.588 3.83301H10.3068C10.1433 2.70682 9.16956 1.83301 8.00012 1.83301ZM8.00012 2.83301C8.62651 2.83301 9.14038 3.25573 9.28723 3.83301H6.71301C6.85987 3.25573 7.37374 2.83301 8.00012 2.83301ZM3.88359 4.83301H12.116L11.2853 13.4131C11.2436 13.8448 10.8894 14.1663 10.4559 14.1663H5.54374C5.11077 14.1663 4.75596 13.8442 4.71432 13.4131L3.88359 4.83301ZM6.82564 6.49251C6.69315 6.49458 6.56689 6.54916 6.47461 6.64425C6.38232 6.73934 6.33156 6.86718 6.33346 6.99967V11.9997C6.33252 12.0659 6.34476 12.1317 6.36947 12.1932C6.39417 12.2547 6.43085 12.3106 6.47738 12.3578C6.5239 12.405 6.57933 12.4425 6.64046 12.4681C6.70159 12.4936 6.76719 12.5068 6.83346 12.5068C6.89972 12.5068 6.96532 12.4936 7.02645 12.4681C7.08758 12.4425 7.14301 12.405 7.18954 12.3578C7.23606 12.3106 7.27274 12.2547 7.29745 12.1932C7.32215 12.1317 7.33439 12.0659 7.33346 11.9997V6.99967C7.33442 6.93275 7.32193 6.86632 7.29674 6.80431C7.27156 6.7423 7.23418 6.68598 7.18682 6.63869C7.13946 6.59139 7.0831 6.55408 7.02105 6.52897C6.95901 6.50387 6.89256 6.49147 6.82564 6.49251ZM9.15898 6.49251C9.02648 6.49458 8.90023 6.54916 8.80794 6.64425C8.71566 6.73934 8.66489 6.86718 8.66679 6.99967V11.9997C8.66585 12.0659 8.67809 12.1317 8.7028 12.1932C8.72751 12.2547 8.76419 12.3106 8.81071 12.3578C8.85723 12.405 8.91267 12.4425 8.9738 12.4681C9.03493 12.4936 9.10053 12.5068 9.16679 12.5068C9.23305 12.5068 9.29866 12.4936 9.35978 12.4681C9.42091 12.4425 9.47635 12.405 9.52287 12.3578C9.56939 12.3106 9.60607 12.2547 9.63078 12.1932C9.65549 12.1317 9.66773 12.0659 9.66679 11.9997V6.99967C9.66775 6.93275 9.65527 6.86632 9.63008 6.80431C9.60489 6.7423 9.56751 6.68598 9.52015 6.63869C9.4728 6.59139 9.41643 6.55408 9.35439 6.52897C9.29235 6.50387 9.2259 6.49147 9.15898 6.49251Z"
                      fill="#333333"
                  />
                </svg>
              </label>
            </div>
          </div>

          <div class="form-group mb-2">
            <button
                class="
                w-full
                h-12
                rounded
                text-sm
                py-13
                pl-4
                pr-4
                border
                solid
                border-green
                background-green
                text-white
                font-medium
              "
                :class="{ 'disabled:opacity-50': disablePopupBtn }"
                :disabled="disablePopupBtn"
                @click="saveDoc"
            >
              {{ $t("pages.common.buttons.dis58") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SearchCard from "../../components/cards/SearchCard";
import {isEmpty} from "lodash";
import LoadingSpinner from "@/components/LoadingSpinner";
import {mapGetters} from "vuex";

export default {
  name: "ProfileEdit",
  components: {LoadingSpinner, SearchCard},
  data() {
    return {
      firstName: "",
      lastName: "",
      cell: "",
      pic: {
        original: null,
        thumb: null,
      },
      openDocPopup: false,
      documents: [],
      popup: {
        title: "",
        details: "",
        document: {
          original: null,
          thumb: null,
        },
      },
      availabilityDate: "",
      documentfile: localStorage.getItem("DocumentUploaded"),
      mxLimitCount: 255,
      RemainCountTotal: 0,
      previewMsg: "",
      displayError: false,
      documentsList: [],
      readMore: {},
    };
  },

  computed: {
    disablePopupBtn() {
      return this.popup.details === "" || this.popup.document.original === null;
    },
    disableSaveBtn() {
      return (
          this.firstName === "" ||
          this.lastName === "" ||
          this.cell === "" ||
          this.availabilityDate === ""
      );
    },
    ...mapGetters("application", {
      details: "selected",
    }),
  },
  created() {
    if (isEmpty(this.user)) {
      this.$store.dispatch("user/fetchProfile").then((res) => {
        if (res !== false) {
          //this.$i18n.locale = res.language;
        }
      });
    }
    this.$store.dispatch("user/fetchProfile").then((res) => {
      this.documentsList = res.references;
      //this.$i18n.locale = res.language;
    });
    let interval = setInterval(() => {
      if (!isEmpty(this.user)) {
        this.firstName = this.user.first_name;
        this.lastName = this.user.last_name;
        this.cell = this.user.cell;
        clearInterval(interval);
      }
    }, 200);
  },
  methods: {
    save() {
      let formData = new FormData();

      let code = ["7471112426", "9340014930"].includes(this.cell)
          ? "+91"
          : "+49";

      formData.append("first_name", this.firstName);
      formData.append("last_name", this.lastName);
      formData.append("telefon", code + this.cell);
      formData.append("availability_date", this.availabilityDate);

      if (this.pic.original) {
        formData.append("pic", this.pic.original);
      }
      for (let i = 0; i < this.documents.length; i++) {
        formData.append(`documents[${i}][title]`, this.documents[i].title);
        formData.append(`documents[${i}][desc]`, this.documents[i].desc);
        formData.append(`documents[${i}][file]`, this.documents[i].file);
      }

      this.$store.dispatch("user/saveProfile", formData).then(() => {
        this.$store.commit("app/showNotification", {
          heading: this.$t("pages.common.buttons.dis89"),
          buttons: {
            okay: {
              text: "Ok",
              action: () => {
                this.loading = true;
                location.reload();
                this.$store.dispatch("user/fetchProfile").then((res) => {
                  if (res !== false) {
                    //this.$i18n.locale = res.language;
                  }
                  this.loading = false;
                });
              },
            },
          },
          icon: {
            show: true,
            type: "success",
          },
        });
      });
    },
    deleteicons(id, val) {
      this.$store.dispatch("user/deleteReference", id);
    },

    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    onlyNumber($event) {
      //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }

      if (this.cell.length >= 11) {
        $event.preventDefault();
      }
    },
    handleFileUpload(type, event) {
      if (type === "profile-pic") {
        let file = this.$refs.profilePic.files;
        if (file && file[0]) {
          this.pic.original = event.target.files[0];
          this.user.pic_url_thumb = URL.createObjectURL(event.target.files[0]);
          let reader = new FileReader();
          reader.onload = (e) => {
            this.pic.thumb = e.target.result;
          };
          reader.readAsDataURL(file[0]);
        }
      } else if (type === "document") {
        let file = this.$refs.document.files;
        if (file && file[0]) {
          this.popup.document.original = file[0];
          localStorage.setItem("DocumentUploaded", event.target.files[0].name);
          this.popup.document.thumb = event.target.files[0];
          this.documentfile = event.target.files[0].name;

        }
      }
    },
    saveDoc() {
      this.documents = [];
      this.documents.push({
        title: this.popup.title,
        desc: this.popup.details,
        file: this.popup.document.thumb,
      });

      this.popup.title = "";
      this.popup.details = "";
      this.popup.document.original = null;
      this.popup.document.thumb = null;
      this.documentfile;
      this.openDocPopup = false;
      this.RemainCountTotal = 0;
    },
    isLetter(event) {
      let char = String.fromCharCode(event.keyCode); // Get the character
      if (/^[A-Za-z -]+$/.test(char)) return true;
      else event.preventDefault(); // If not match, don't add to input text
    },
    displayLiveCDown: function () {
      if (this.popup.details.length === 255) {
        this.displayError = true;
      } else {
        this.displayError = false;
      }
      this.RemainCountTotal = this.popup.details.length;
      // this.displayError = this.RemainCountTotal > 255;
    },
  },
};
</script>

<style scoped>
body {
  padding-bottom: 0 !important;
}

.documentfilecolor {
  color: #63b15b;
  padding-left: 24px;
  position: relative;
  top: -19px;
}

.iconcolors {
  color: #63b15b;
}

.deleteicons {
  color: #63b15b;
  position: absolute;
  right: 20px;
  bottom: 34px;
}

.error {
  border: 1px solid #ee5b64;
  box-sizing: border-box;
  border-radius: 4px;
}

.error-msg {
  width: 173px;
  height: 20px;
  left: 0;
  top: 184px;
  font-family: Quicksand, serif;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 154.5%;
  color: #ee5b64;
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
@media only screen and (max-width: 767px) {
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
</style>
